module.exports = __webpack_public_path__ + "img/senecare.499fb50c.png";